import styled, { css } from 'styled-components';
import { Stack, Box } from '@koob/margaret';
import { fontStyles } from './theme';

export const FormGroup = styled.div`
  > * {
    margin-bottom: ${({ theme }) => theme.spacing(1.5)};
  }
`;

export const FormLabel = styled(Box).attrs({ as: 'label', marginBottom: 0.5 })`
  ${fontStyles.bodySmall};

  margin-bottom: ${({ theme }) => theme.spacing(0.5)};
  font-weight: 600;
  color: ${({ theme }) => theme.text};

  ${({ variant }) =>
    variant === 'bare' &&
    `
      margin-bottom: 0;
    `}
`;

export const FormField = styled(Stack).attrs({
  direction: 'column',
  size: 'full',
  alignX: 'stretch',
})`
  flex: 1;
  position: relative;
`;

styled(Stack).attrs({
  direction: 'row',
  alignY: 'center',
})``;

export const HelperText = styled.div`
  ${fontStyles.bodySmall};
  color: ${({ theme }) => theme.textLight};
  padding-top: ${({ theme }) => theme.spacing(0.5)};
`;

export const ErrorMessageWrapper = styled.div`
  ${fontStyles.bodySmall};

  color: ${({ theme }) => theme.danger};
  position: absolute;
  top: 100%;
`;

export const FormErrorMessage = styled.span`
  display: block;
  padding-top: ${({ theme }) => theme.spacing(0.5)};
  color: ${({ error, theme }) => (error ? theme.error : theme.warning)};
  font-size: 14px;
`;

export const FieldsContainer = styled.div`
  margin-top: ${({ theme }) => theme.spacing()};
`;

export const RoomTitle = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: gray;
  ${props =>
    props.condition &&
    css`
      color: #000;
    `}
`;
